import * as React from 'react';
import { RegionsButton } from '../../components/RegionsButton';
import { RegionsModalContainer } from '../RegionsModal';
import { useSelector } from 'react-redux';
import { selectCurrentRegion } from '../../selectors/region';

export function RegionsContainer() {
  const [open, setOpen] = React.useState(false);
  const handleButtonClick = React.useCallback(() => setOpen(true), []);
  const handleCloseModal = React.useCallback(() => setOpen(false), []);
  const { displayName: currentRegionName } = useSelector(selectCurrentRegion);

  return (
    <>
      <RegionsButton onClick={handleButtonClick}>{currentRegionName}</RegionsButton>
      <RegionsModalContainer open={open} onClose={handleCloseModal} />
    </>
  );
}
